import videojs from 'video.js';

const _tbody = new WeakMap();

export class LogTable extends videojs.getComponent('Component') {
    constructor(player, options) {
        super(player, options);

        const thead = this.el().appendChild(document.createElement('thead'));
        const sourceEl = thead.appendChild(document.createElement('th'));
        const descriptionEl = thead.appendChild(document.createElement('th'));
        const timeEl = thead.appendChild(document.createElement('th'));

        sourceEl.textContent = 'Source';
        descriptionEl.textContent = 'Description';
        timeEl.textContent = 'Time';

        const tbody = this.el().appendChild(document.createElement('tbody'));
        _tbody.set(this, tbody);
    }

    createEl(tag, props = {}, attributes = {}) {
        tag = 'table';
        return super.createEl.call(this, tag, props, attributes);
    }

    addLog({ source, description, time }) {
        const tbody = _tbody.get(this);

        const tr = tbody.appendChild(document.createElement('tr'));
        const sourceEl = tr.appendChild(document.createElement('td'));
        const descriptionEl = tr.appendChild(document.createElement('td'));
        const timeEl = tr.appendChild(document.createElement('td'));

        sourceEl.textContent = source;
        descriptionEl.textContent = description;
        timeEl.textContent = new Date(time).toLocaleTimeString();
    }
}
